
import { Link } from 'react-router-dom';

export default function CTAWorksheet() {
  return (
    <section className="py-24 bg-gradient-to-br from-[#1A1A1A] to-[#2A2A2A] relative overflow-hidden print:hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent"></div>
      <div className="absolute top-20 left-20 w-[400px] h-[400px] bg-[#D4AF37]/[0.03] rounded-full blur-[120px]"></div>
      <div className="absolute bottom-20 right-20 w-[300px] h-[300px] bg-[#D4AF37]/[0.03] rounded-full blur-[100px]"></div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <i className="ri-rocket-2-line text-5xl text-[#D4AF37] mb-6 block"></i>

        <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
          Pronto Para Transformar Sua <span className="text-[#D4AF37] italic">Identidade</span>?
        </h2>

        <p className="font-['Montserrat'] text-lg text-white/70 max-w-2xl mx-auto leading-relaxed mb-10">
          Suas Encantations são o primeiro passo. Para uma transformação completa,
          explore nossos exercícios avançados de PNL e alta performance.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
          <Link
            to="/exercicio/encantations-tony-robbins"
            className="px-8 py-4 bg-[#D4AF37] text-black font-semibold rounded-lg hover:bg-[#C5A028] transition-all shadow-lg hover:shadow-xl flex items-center gap-2 whitespace-nowrap"
          >
            <i className="ri-play-circle-line text-lg"></i>
            Exercício Completo de Encantations
          </Link>
          <Link
            to="/exercicio/ancoragem-pnl"
            className="px-8 py-4 bg-white/5 border border-white/15 text-white font-semibold rounded-lg hover:bg-white/10 transition-all flex items-center gap-2 whitespace-nowrap"
          >
            <i className="ri-brain-line text-lg"></i>
            Ancoragem Emocional PNL
          </Link>
        </div>

        {/* Exercícios Relacionados */}
        <div className="grid md:grid-cols-3 gap-6">
          <Link
            to="/exercicio/identidade-alta-performance"
            className="group bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:border-[#D4AF37]/30 transition-all hover:-translate-y-1"
          >
            <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center mb-4 mx-auto">
              <i className="ri-shield-star-line text-2xl text-[#D4AF37]"></i>
            </div>
            <h3 className="font-['Playfair_Display'] text-lg font-bold text-white mb-2 group-hover:text-[#D4AF37] transition-colors">
              Identidade de Alta Performance
            </h3>
            <p className="font-['Montserrat'] text-sm text-white/50">
              Construa a mentalidade da sua melhor versão
            </p>
          </Link>

          <Link
            to="/exercicio/proposito-vida"
            className="group bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:border-[#D4AF37]/30 transition-all hover:-translate-y-1"
          >
            <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center mb-4 mx-auto">
              <i className="ri-compass-3-line text-2xl text-[#D4AF37]"></i>
            </div>
            <h3 className="font-['Playfair_Display'] text-lg font-bold text-white mb-2 group-hover:text-[#D4AF37] transition-colors">
              Propósito de Vida
            </h3>
            <p className="font-['Montserrat'] text-sm text-white/50">
              Descubra o que você veio fazer neste mundo
            </p>
          </Link>

          <Link
            to="/planos"
            className="group bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:border-[#D4AF37]/30 transition-all hover:-translate-y-1"
          >
            <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center mb-4 mx-auto">
              <i className="ri-star-line text-2xl text-[#D4AF37]"></i>
            </div>
            <h3 className="font-['Playfair_Display'] text-lg font-bold text-white mb-2 group-hover:text-[#D4AF37] transition-colors">
              Todos os Exercícios
            </h3>
            <p className="font-['Montserrat'] text-sm text-white/50">
              Explore nossa coleção completa de transformação
            </p>
          </Link>
        </div>

        {/* Footer simples */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gradient-to-br from-[#D4AF37] to-[#F4E4C1] rounded-lg flex items-center justify-center">
                <i className="ri-heart-3-fill text-sm text-[#1a1a1a]"></i>
              </div>
              <span className="font-bold text-white/80 text-sm">Cartas de Gratidão</span>
            </Link>
            <p className="font-['Montserrat'] text-xs text-white/30">
              © 2025 Carta do Eu Futuro. Todos os direitos reservados.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="font-['Montserrat'] text-xs text-white/30 hover:text-[#D4AF37] transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
